export const FILTERS = {
  TYPE: "type",
  CHAT_ID: "chatId",
  DATE: "date",
  INIT_DATE: "initDate",
  END_DATE: "endDate",
  CHANNEL: "channel",
  STATE: "state",
  STATUS: "status",
  LABEL: "label",
  ACTIVE: "active",
  USERNAME: "username",
  KEYWORD: "keyword",
  AREA_NAME: "area_name",
  LEAD_SCORE: "lead_score",
  ORIGIN: "origin",
};
export const FILTER_TYPE_CHAT = {
  ALL: "all",
  CONTACT_REQUESTS: "contact_requests",
  BOT_CHATS: "bot_chats",
  LIVE_CHATS: "live_chats",
};
export const FILTER_CHANNEL_CHAT = {
  ALL: "",
  WEBCHAT: "Webchat",
  WHATSAPP: "WhatsApp",
  FACEBOOK: "Facebook",
  INSTAGRAM: "Instagram",
};

export const FILTER_ACTIVE_CHAT = {
  ALL: "",
  ACTIVE: "only_active",
  INACTIVE: "only_inactive",
};
export const FILTER_STATE_CHAT = {
  ALL: "",
  UNASSIGNED: "sinasignar",
  ASSIGNED: "asignadas",
};
export const FILTER_STATUS_CHAT = {
  ALL: "",
  READ: "leidas",
  UNREAD: "no_leidas",
  UNANSWERED: "no_contestadas",
};

export const FILTER_ORIGIN_CHAT = {
  ALL: "all",
  AD: "ad",
  CAMPAIGN: "campaign",
};

export const CHAT_CATEGORIES = {
  CHATS: "nuevas",
  ARCHIVE: "resueltas",
};

export const CHAT_REDUCER_ACTIONS = {
  SET_CHAT: "SET_CHAT",
  ADD_NEW_MESSAGE: "ADD_NEW_MESSAGE",
  ADD_OPTIMISTIC_MESSAGE: "ADD_OPTIMISTIC_MESSAGE",
  UPDATE_OPTIMISTIC_MESSAGE: "UPDATE_OPTIMISTIC_MESSAGE",
  UPDATE_MESSAGE: "UPDATE_MESSAGE",
  UPDATE_CHAT_INFO: "UPDATE_CHAT_INFO",
  UPDATE_CHAT_IN_MENU: "UPDATE_CHAT_IN_MENU",
  UPDATE_FILTER_CHATS_IN_MENU: "UPDATE_FILTER_CHATS_IN_MENU",
  DELETE_CHAT_IN_MENU: "DELETE_CHAT_IN_MENU",
  UPDATE_USER_INFO: "UPDATE_USER_INFO",
  CLEAR_CHAT: "CLEAR_CHAT",
  SET_CHATS: "SET_CHATS",
  CHANGE_CATEGORY: "CHANGE_CATEGORY",
  SET_FILTER_SELECTED: "SET_FILTER_SELECTED",
  SET_LOADING: "SET_LOADING",
  SET_AREAS_AND_CONTACTS: "SET_AREAS_AND_CONTACTS",
  OPEN_MOBILE_TAB: "OPEN_MOBILE_TAB",
  CLOSE_MOBILE_TAB: "CLOSE_MOBILE_TAB",
  CHANGE_DIALOG: "CHANGE_DIALOG",
  SET_LABELS: "SET_LABELS",
  SET_ACTIONS_LABELS: "SET_ACTIONS_LABELS",
  SET_QUICK_REPLIES: "SET_QUICK_REPLIES",
  CHANGE_DISABLED_BUTTONS: "CHANGE_DISABLED_BUTTONS",
  INIT_STATES: "INIT_STATES",
  ADD_NEW_CHAT: "ADD_NEW_CHAT",
  SET_CONTACTS_GROUPS: "SET_CONTACTS_GROUPS",
  UPDATE_MESSAGE_STATUS: "UPDATE_MESSAGE_STATUS",
  SET_LEAD_QUALITY_SCORE: "SET_LEAD_QUALITY_SCORE",
  SET_CLOSED_CHAT: "SET_CLOSED_CHAT",
  // ADD_NEW_CONTACT: "ADD_NEW_CONTACT"
};

export const ALLOWED_IMAGE_FILES = [
  "image/gif",
  "image/jpeg",
  "image/webp",
  "image/png",
  "image/jpg",
  "image",
];

export const ALLOWED_VIDEO_FILES = [
  "video/mp4",
  "video/webm",
  "video/ogg",
  "video",
];
export const ALLOWED_AUDIO_FILES = [
  "audio/x-wav",
  "audio/mpeg",
  "audio/ogg",
  "audio/mp3",
  "audio",
];

export const ALLOWED_DOCUMENT_FILES = [
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain", // .txt
  "text/csv",
  "application/json",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "text/sql",
];

export const ALLOWED_SENDER_FILES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "audio/ogg",
  "audio/mp3",
  "audio/mpeg",
  "audio/wav",
  "audio/x-wav",
  "video/ogg",
  "application/ogg",
  ...ALLOWED_DOCUMENT_FILES,
];
